import { Pipe, PipeTransform } from '@angular/core';
import { CurrentCartItemAvailability } from 'app/features/cart';

/**
 * CartCurrentListItemAvailablityPipe
 *
 * This pipe can be used to extract the availability by cart item id
 */
@Pipe({
  name: 'cartCurrentListItemAvailablity',
})
export class CartCurrentListItemAvailablityPipe implements PipeTransform {
  /**
   * Transform a cart item to it's availabilities
   *
   * @param availablities Cart item availabilities
   * @param cartId Cart item id
   * @returns Cart item availability
   */
  transform(availablities: CurrentCartItemAvailability[], cartId: number): CurrentCartItemAvailability {
    if (!availablities || !cartId) {
      return;
    }

    return availablities.find((av) => av?.CurrentCartItemId === cartId);
  }
}
